
const bankList  = () => import ('@/pages/bank/bank-list')
const bankAdd  = () => import ('@/pages/bank/bank-add')
const bankInfo  = () => import ('@/pages/bank/bank-info')
export default [
    {
        path: 'bank/bankList',
        name:'bank/bankList',
        component: bankList
    },
    {
        path: 'bank/bankAdd',
        name:'bank/bankAdd',
        component: bankAdd
    },
    {
      path: 'bank/bankInfo',
      name:'bank/bankInfo',
      component: bankInfo
  },

]



// WEBPACK FOOTER //
// ./src/router/bank.js